import { render, staticRenderFns } from "./HowItWorkBlock.vue?vue&type=template&id=27679cc1"
import script from "./HowItWorkBlock.vue?vue&type=script&lang=js"
export * from "./HowItWorkBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports